import { HttpClient, serializeJSONApiData } from '@opallabs/api'
import loadWorkflow from '../loadWorkflow'

const patchWorkflow = ({ identifier, type, workflowId, params }) =>
  HttpClient().patch(
    `/api/v1/${
      type && identifier ? `${type}/${identifier}/` : ''
    }workflow/${workflowId}`,
    { data: params.data }
  )

const updateWorkflow =
  ({ identifier, workflowId, type, updatedWorkflow }) =>
  (dispatch) => {
    const params = serializeJSONApiData('phase-group', {
      ...updatedWorkflow,
      id: workflowId,
    })
    patchWorkflow({
      identifier,
      type,
      workflowId,
      params,
    })
      .then((response) => dispatch(loadWorkflow(response.data)))
      .catch((err) => {
        console.log(err)
        throw err
      })
  }

export default updateWorkflow
